import { useState, MouseEvent } from "react";
import { useLocation, useNavigate, useRouteLoaderData, useSearchParams } from "react-router-dom"
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import likeimg from "src/img/community/like.png";
import likedimg from "src/img/community/liked.png";
//import dislikeimg from "src/img/community/dislike.png";
//import dislikedimg from "src/img/community/disliked.png";
import { myAxios, objAscSort } from "src/components/common/functions";
import { useAuthStore, User } from "src/components/main/authStore";
import { Link } from "react-router-dom";
import PostReplyForm from "./PostReplyForm";
import { Post, emptyPost } from "./types";
//---------------------------------------------------------------------
export default function PostDetail(){
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const action = searchParams.get("action");
    const replyId = searchParams.get("replyId");
    const replyTo = searchParams.get("replyTo");
    const closeIt = () => navigate("..");
    const deletePost = async (e:MouseEvent<HTMLButtonElement>) => {
        if(!window.confirm("Are you sure to delete this post?")) return;
        const formData = new FormData();
        formData.append("id", e.currentTarget.id);
        //---------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "community/deletePost.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------------
        closeIt();
    }
    const [post, setPost] = useState<Post>(useRouteLoaderData("post") ?? emptyPost);
    const navigate = useNavigate();
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const user = useAuthStore(state => state.user) as User;
    const [reply, setReply] = useState("");
    return(
        <div className = "px-3 py-2">
            <Link
                children = "Posts List"
                className = "btn btn-secondary float-end"
                to = ".."
            />
            <h1>{post.subject}</h1>
            <div className = "border rounded p-3">
                <div className = "" style = {{whiteSpace: "pre-wrap"}}>
                    {post.body}
                    {post.photos && post.photos.length? <div className = "mt-4">{post.photos.map((photo, i) => 
                    <img
                        key = {photo.id || i}
                        style = {{maxWidth: "100%"}}
                        className = "my-3"
                        src = {photo.url} 
                        alt = ""
                    />)}</div>:null}
                    <div className = "m-3 text-right">
                        {Number(post.liked)?
                        <button
                            children = {<img src = {likedimg} width = {30} alt = "" className = "pointer"/>}
                            type = "button"
                            className = "noButtonStyle me-3"
                            onClick = {async () => {
                                const formData = new FormData();
                                formData.append("id", post.id);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "community/cancelLike.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                setPost(post => ({...post, ...res.data}));
                            }}
                        />
                        :
                        <button
                            children = {<img src = {likeimg} width = {30} alt = "" className = "pointer"/>}
                            type = "button"
                            className = "noButtonStyle me-3"
                            onClick = {async () => {
                                const formData = new FormData();
                                formData.append("id", post.id);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "community/like.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                setPost(post => ({...post, ...res.data}));
                            }}
                        />
                        }
                        <span className = "fw-bold">{post.likesCount}</span>
                    </div>
                </div>
                {post.replies.sort((a, b) => objAscSort(a, b, "createdAt")).map((renderedReply, renderedReplyIndex) => 
                <div key = {renderedReplyIndex} className = "my-3">
                    <div style = {{whiteSpace: "pre-wrap"}}>
                        <UserInfo 
                            name = {renderedReply.creatorName}
                            id = {renderedReply.creatorId}
                        />
                        {renderedReply.replyToName && renderedReply.replyToId?<> to <UserInfo 
                            name = {renderedReply.replyToName}
                            id = {renderedReply.replyToId}
                        /></>:null}
                        &nbsp;&nbsp;:&nbsp;&nbsp;
                        {renderedReply.body}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {Number(renderedReply.liked)?
                        <button
                            children = {<img src = {likedimg} width = {30} alt = "" className = "pointer"/>}
                            type = "button"
                            className = "noButtonStyle me-3"
                            onClick = {async () => {
                                const formData = new FormData();
                                formData.append("id", renderedReply.id);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "community/cancelLike.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                setPost({...post, replies: post.replies.map(eachReply => eachReply.id === renderedReply.id ? ({...eachReply, ...res.data}): eachReply)});
                            }}
                        />
                        :
                        <button
                            children = {<img src = {likeimg} width = {30} alt = "" className = "pointer"/>}
                            type = "button"
                            className = "noButtonStyle me-3"
                            onClick = {async () => {
                                const formData = new FormData();
                                formData.append("id", renderedReply.id);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "community/like.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                setPost({...post, replies: post.replies.map(eachReply => eachReply.id === renderedReply.id ? ({...eachReply, ...res.data}): eachReply)});
                            }}
                        />}
                        <span className = "fw-bold me-3">{renderedReply.likesCount}</span>
                        {renderedReply.updatedAt?<span className = "me-3 badge badge-secondary">edited</span>:null}
                        <span className = "me-3 text-secondary">{renderedReply.updatedAt ?? renderedReply.createdAt}</span>
                        <Link children = "Reply" className = "btn btn-primary me-3"
                            to = {`${location.pathname}?${new URLSearchParams({
                                ...Object.fromEntries(new URLSearchParams(location.search)),
                                action: "Reply", 
                                replyTo: renderedReply.creatorId
                            })}`} replace
                        />
                        {action === "Reply" && replyTo === renderedReply.creatorId?
                        <PostReplyForm post = {post} setPost = {setPost} reply = {emptyPost}/>:null}
                        {renderedReply.creatorId === user.id?<>
                        <Link children = "Edit" className = "btn btn-primary me-3"
                            to = {`${location.pathname}?${new URLSearchParams({
                                ...Object.fromEntries(new URLSearchParams(location.search)),
                                action: "Edit",
                                replyId: renderedReply.id
                            })}`} replace
                        />
                        {action === "Edit" && replyId === renderedReply.id?
                        <PostReplyForm post = {post} setPost = {setPost} reply = {renderedReply}/>:null}
                        <button
                            children = "Delete"
                            type = "button"
                            className = "ms-3 btn btn-danger"
                            onClick = {async e => {
                                if(!window.confirm("Are you sure to delete this post?")) return;
                                const formData = new FormData();
                                formData.append("parentId", post.id);
                                formData.append("id", renderedReply.id);
                                //---------------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "community/deletePost.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------------------
                                setPost({...post, ...res.data});
                            }}/>
                        </>:null}
                    </div>
                </div>)}
            </div>
            {post.creatorId === user.id?
            <div className = "m-3 text-right">
                <Link children = "Edit" className = "btn btn-primary m-3" to = "Edit"/>
                <button
                    children = "Delete"
                    type = "button"
                    className = "btn btn-danger m-3"
                    onClick = {deletePost}
                    id = {post.id} 
                />
            </div>:null}
            <div className = "fw-bold">Comment:</div>
            <textarea className = "form-control" value = {reply} onChange = {e => setReply(e.currentTarget.value)}/>
            <button
                children = "Reply"
                type = "button"
                className = "btn btn-warning float-end m-3"
                onClick = {async e => {
                    e.preventDefault();
                    if(!reply){
                        window.alert("Put something to reply.");
                        return;
                    }
                    const formData = new FormData();
                    formData.append("parentId", post.id);
                    formData.append("body", reply);
                    //---------------------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios({ fileName: "community/createPost.php", formData: formData });
                    setShowLoader(false);
                    if(!res) return;
                    //---------------------------------------------------------------------
                    setPost({...post, ...res.data});
                    setReply("");
                }}
            />
        </div>
    )
}
